import { Component, EventEmitter, OnInit, Output, Renderer2 } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ColumnsDialogComponent } from "../product-safety-strategy/columns-dialog/columns-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { ReportlinksserviceService } from "../../reportlinks/reportlinksservice.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { NewAdhocActivityPopupComponent } from "./new-adhoc-activity-popup/new-adhoc-activity-popup.component";
import { constants } from "src/app/shared/common/contants";
import { CreateSignalPopupComponent } from "./create-signal-popup/create-signal-popup.component";
import { DeviationComponent } from "../../deviation/deviation.component";
import { UserRoutingModule } from "../../user-routing/user-routing.module";
import { CalendarEvent } from "src/app/shared/models/calendar-event";
import { ActionCalendarComponent } from "../../action-calendar/action-calendar.component";
import { ReviewActivityReportFiltersService } from "src/app/shared/services/review-activity-report-filters.service";

interface Activity {
  pssName: string;
  version: any;
  activityName: string;
  assignee: string;
  type: string;
  startDate: any;
  endDate:any;
  dueDate: any;
  scheduleId:any;
  uploadInstructions:any;
  evidenceRequired:any
  scheduleState:any;
  isOverdue:any;
  reviewActivityType:any;
}

@Component({
    selector: "app-review-activities",
    templateUrl: "./review-activities.component.html",
    styleUrls: ["./review-activities.component.scss"],
    standalone: false
})
export class ReviewActivitiesComponent implements OnInit {
  stats: any;
  errorMessage = "";
  backgroundColorButton: string;
  backgroundColorScreen: any;
  // AG-Grid defaults
  defaultColDef;
  columnDefs;
  // if the record has status==no , row color will change
  rowClassRules ;
  getRowStyle = (params: any) => {
    console.log(params);
    console.log(params.data.status);
    if (params.data.status === "No") {
      return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
    }
    // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
  };
  isDownloading = false;
  RunpageSize = 10;
  value: any;
  paginationPageSize: any;
  paginationNumberFormatter: any;
  components: any;
  gridAPI: any;
  gridColumnAPI: any;
  gridmgrnAPI: any;
  RuncurrentPage;
  RuntotalPages;
  RunlastPage;
  RunnextPage;
  RunnextPagePlusOne;
  gridRowData = [];
  toggleableCols: Array<{ headerName: string; field: string }> = [];
  selectedFields: string[] = []; // currently visible fields (for the mat-select)
  datasets: any;
  selectedDataset: any = null;
  getdata: any;
  UserRolesWithRoleId: any;
  rowbindingdata: any;
  //Below Flag Is Used o Enable the Review Work Flow Screen
  showWorkflow = false;
  instancedetailid:any
  selectedActivity: Activity = {
    pssName: "",
    version: "",
    activityName: "",
    assignee: "",
    type: "",
    startDate: "",
    endDate:"",
    dueDate: "",
    scheduleId:"",
    uploadInstructions:"",
    evidenceRequired:"",
    scheduleState:"",
    isOverdue:"",
    reviewActivityType:""
  };
  selectedActivityReportTemplate:any;
  UserRoleName: any;
  newCount = 0;
  inReviewCount = 0;
  completedCount = 0;
  overdueCount = 0;
  signalDetectedCount = 0;
  activeFilter: string | null = null;
  clickTimeout: any = null;
  latestApprovedPSS:any[];
  deviationFor="Review Activity";
  isSidenavOpen=false

   pageSize = 50;
  currentPage = 1;
  totalPages = 1;
  totalRows = 0;
  startRow = 1;
  endRow = 50;

  queryData:any;
  constructor(
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private router: Router,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private jsignalsService: JsignalService,
    public dialog: MatDialog,
    private linkservice: ReportlinksserviceService,
    private service: ReportingServiceService,
    private constants: constants,
    private userRoutingModule: UserRoutingModule,
    private route: ActivatedRoute,
    private reviewAcitivityReportFiltersServices:ReviewActivityReportFiltersService
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit(): void {
     this.queryData=history.state?.selectedRowData
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.columnDefs = [
      {
      headerName: "Action",
      filter: false,
      headerTooltip: "Action",
      cellRenderer: "jsignalButton",
      pinned: "left",
      lockPinned: true,
      cellRendererParams: {
        onAssign: this.onSelectAssign.bind(this),
        onStartReview: this.onStartReview.bind(this),
        onSignalCreation: this.onSignalCreation.bind(this),
        onDeviationCreation: this.onDeviationCreation.bind(this),
        delete: this.deleteIcon.bind(this),
      },
      width: 280,
      hide: false,
    },
    {
      headerName: "Product Name",
      field: "productName",
      filter: "agTextColumnFilter",
      headerTooltip: "Product Name",
      tooltipValueGetter: (params) => "Product Name : " + params.value,
      hide: false,
      width: 200,
    },
    {
      headerName: "Product State",
      field: "productState",
      filter: "agTextColumnFilter",
      headerTooltip: "Product State",
        tooltipValueGetter: (params) => {
        const value = params.value;
        if (value === "active__v") return "Product State : Active";
        if (value === "inactive__v") return "Product State : Inactive";
        return "Product State : " + (value || "");
      },
      hide: false,
      width: 180,

      //Custom cell renderer for colored label
      cellRenderer: (params) => {
        const value = params.value;
        if (value === "active__v") {
          return `<span style="color: green; font-weight: 600;">Active</span>`;
        }
        return `<span>${value || ""}</span>`;
      },

      // Optional: make sure raw value (not HTML) is used for filtering/sorting
      cellRendererParams: { suppressHtmlEscaping: false },
    },
    {
      headerName: "PSS Name",
      field: "pssName",
      filter: "agTextColumnFilter",
      headerTooltip: "PSS Name",
      tooltipValueGetter: (params) => "PSS Name : " + params.value,
      hide: false,
      width: 200,
    },
    {
      headerName: "Version",
      field: "version",
      filter: "agTextColumnFilter",
      headerTooltip: "Version",
      tooltipValueGetter: (params) => "Version : " + params.value,
      hide: false,
      width: 200,
    },
    {
      headerName: "Assignee",
      field: "asignedUser",
      filter: "agTextColumnFilter",
      headerTooltip: "Assignee",
      tooltipValueGetter: (params) => "Assignee : " + params.value,
      hide: false,
      width: 150,
    },
    {
      headerName: "Activity Name",
      field: "activity",
      filter: "agSetColumnFilter",
      headerTooltip: "Activity Name",
      tooltipValueGetter: (params) => "Activity Name : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Activity Type",
      field: "reviewActivityType",
      filter: "agSetColumnFilter",
      headerTooltip: "Activity Type",
      tooltipValueGetter: (params) => "Activity Type : " + params.value,
      hide: false,
      width: 180,
    },
     {
      headerName: "Review Type",
      field: "state",
      filter: "agSetColumnFilter",
      headerTooltip: "Review Type",
      tooltipValueGetter: (params) => "Review Type : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Signal Detected",
      field: "signaldetected",
      filter: "agSetColumnFilter",
      headerTooltip: "Signal Detected",
      tooltipValueGetter: (params) => {
        const val = params.value;
        return "Signal Detected : " + (val === 1 || val === "1" ? "Yes" : "No");
      },
      hide: false,
      width: 180,
      valueFormatter: (params) => {
        const val = params.value;
        return val === 1 || val === "1" ? "Yes" : "No";
      },

    // IMPORTANT: Make filter search case-insensitive on 'Yes'/'No'
      filterParams: {
        textFormatter: (value) => value.toLowerCase(),
        textMatcher: ({ value, filterText }) => {
          const displayVal = value === 1 || value === "1" ? "yes" : "no";
          return displayVal.includes(filterText.toLowerCase());
        }
      },
    },
    {
      headerName: "Activity Level",
      field: "level",
      filter: "agSetColumnFilter",
      headerTooltip: "Activity Level",
      tooltipValueGetter: (params) => "Activity Level : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Periodicity",
      field: "reviewPeriod",
      filter: "agSetColumnFilter",
      headerTooltip: "Periodicity",
      tooltipValueGetter: (params) => "Periodicity : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "State ",
      field: "scheduleState",
      filter: "agTextColumnFilter",
      headerTooltip: "State",
      tooltipValueGetter: (params) => "State : " + params.value,
      hide: false,
      width: 100,
    },
    // {
    //   headerName: "State",
    //   field: "state",
    //   tooltipField: "state",
    //   width: 160,
    //   cellRenderer: (params: any) => {
    //     const state = params.data.state; // display text
    //     const stateCode = params.data.stateCode; // color based on this
    //     let badgeClass = "";

    //     // Map stateCode to badge classes
    //     switch (stateCode) {
    //       case "1":
    //         badgeClass = "state-badge draft";
    //         break;
    //       case "2":
    //         badgeClass = "state-badge review";
    //         break;
    //       case "3":
    //         badgeClass = "state-badge approval";
    //         break;
    //       case "4":
    //         badgeClass = "state-badge approved";
    //         break;
    //       case "5":
    //         badgeClass = "state-badge superseded";
    //         break;
    //       default:
    //         badgeClass = "state-badge default";
    //     }

    //     return `
    // <span class="${badgeClass}">
    //   <span class="dot"></span>${state}
    // </span>`;
    //   },
    // },
    // {
    //   headerName: "Author ",
    //   field: "author",
    //   filter: "agNumberColumnFilter",
    //   tooltipField: "author",
    //   hide: false,
    //   width: 180,
    // },
    // {
    //   headerName: "CreatedBy",
    //   field: "createdBy",
    //   filter: "agNumberColumnFilter",
    //   tooltipField: "createdBy",
    //   hide: true,
    //   width: 180,
    // },
    {
      headerName: "Activity Start Date",
      field: "activityStartDate",
      filter: "agSetColumnFilter",
      headerTooltip: "Activity Start Date",
      tooltipValueGetter: (params) => "Activity Start Date : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Activity End Date",
      field: "activityEndDate",
      filter: "agSetColumnFilter",
      headerTooltip: "Activity End Date",
      tooltipValueGetter: (params) => "Activity End Date : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "Activity Completion Date",
      field: "reviewCompletionDate",
      filter: "agSetColumnFilter",
      headerTooltip: "Activity Completion Date",
      tooltipValueGetter: (params) => "Activity Completion Date : " + params.value,
      hide: false,
      width: 200,
    },
    {
      headerName: "Review Due Date",
      field: "activityDueDate",
      filter: "agSetColumnFilter",
      headerTooltip: "Review Due Date",
      tooltipValueGetter: (params) => "Review Due Date : " + params.value,
      hide: false,
      width: 180,
      cellClassRules: {
      "due-date-overdue": (params) =>
      params.data?.isOverdue == true
      }
    },
    // {
    //   headerName: "Last Modified By",
    //   field: "lastModifiedBy",
    //   filter: "agNumberColumnFilter",
    //   tooltipField: "lastModifiedBy",
    //   hide: true,
    //   width: 180,
    // },
    // {
    //   headerName: "Last Modified Date",
    //   field: "lastModifiedDate",
    //   filter: "agNumberColumnFilter",
    //   tooltipField: "lastModifiedDate",
    //   hide: true,
    //   width: 180,
    // },deviationCode
    {
      headerName: "Deviation Id ",
      field: "deviationCode",
      filter: "agTextColumnFilter",
      headerTooltip: "Deviation Id ",
      tooltipValueGetter: (params) => "Deviation Id  : " + params.value,
      hide: false,
      width: 200,
      cellRenderer: 'jsignalButton',
        cellRendererParams: {
    deviationLink: true,
    getDeviationUrl: (params) => this.getDeviationUrl(params)
  }
    },
    {
      headerName: "Deviation State ",
      field: "deviationState",
      filter: "agTextColumnFilter",
      headerTooltip: "Deviation State ",
      tooltipValueGetter: (params) => "Deviation State  : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Deviation Closure Date",
      field: "deviationClosureDate",
      filter: "agSetColumnFilter",
      headerTooltip: "Deviation Closure Date ",
      tooltipValueGetter: (params) => "Deviation Closure Date  : " + params.value,
      hide: false,
      width: 180,
    },
        {
      headerName: "External Sync Status",
      field: "vaultStatus",
      filter: "agTextColumnFilter",
      headerTooltip: "Vault Sync Status",
      tooltipValueGetter: (params) => "Vault Sync Status  : " + params.value,
      hide: true,
      width: 180,
    },
 {  
      headerName: "External Reference ID",
      field: "vaultReferenceId",
      filter: "agTextColumnFilter",
      headerTooltip: "Vault Reference ID",
      tooltipValueGetter: (params) => "Vault Reference ID : " + params.value,
      hide: true,
      width: 180,
    },
    {
    headerName: "Overdue Flag",
    field: "isOverdue",
    filter: "agBooleanColumnFilter",
    headerTooltip: "Overdue Flag",
      tooltipValueGetter: (params) => "Overdue Flag  : " + params.value,
      hide: true,
      width: 180,
    }
    ];
    this.rowClassRules ={
          sick: function (params) {
      var numSickDays = params.node.data.status;
      return numSickDays === "No" || numSickDays === null;
    },
    "row-overdue": (params) => {
    return params.data?.isOverdue == true;
  }
    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
    };
    this.fetchUserRole();
    this.getAllLatestApprovedPSS();
  }



  openColumnsDialog() {
    const dialogRef = this.dialog.open(ColumnsDialogComponent, {
      maxWidth: "100vw",
      height: "55%",
      width: "45%",
      data: {
        toggleableCols: this.toggleableCols,
        selectedFields: this.selectedFields,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: string[] | undefined) => {
      if (result) {
        this.selectedFields = result;
        this.applySelectionToGrid(); // update AG Grid
      }
    });
  }
  // --- helpers ---
  applySelectionToGrid() {
    if (!this.gridColumnAPI) return;

    const selected = new Set(this.selectedFields);

    // toggle only toggleable columns; leave pinned “Action” alone
    for (const c of this.toggleableCols) {
      this.gridColumnAPI.setColumnsVisible([c.field], selected.has(c.field));
    }
  }

  selectAll() {
    this.selectedFields = this.toggleableCols.map((c) => c.field);
    this.applySelectionToGrid();
  }

  clearAll() {
    this.selectedFields = [];
    this.applySelectionToGrid();
  }
  onDownloadhistory() {
    if (this.isDownloading) return;

    this.isDownloading = true;
    this.spinner.start();

    setTimeout(() => {
      this.gridmgrnAPI.exportDataAsCsv({
        fileName: "Activity_Details.csv",
      });

      this.spinner.stop();
      this.isDownloading = false;
    }, 500);
  }
  onrefresh() {
     this.queryData=undefined
    this.loadGridData();
  }
  onRunSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }
  onRunPageSizeChanged(newPageSize) {
    console.log(this.RunpageSize);
    var value = this.RunpageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }
  onRunBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }
  onRunBtPrevious() {
    console.log("previous");
    this.gridAPI.paginationGoToPreviousPage();
  }
  onRunBtNext() {
    console.log("next");
    this.gridAPI.paginationGoToNextPage();
  }
  onRunBtLast() {
    this.gridAPI.paginationGoToLastPage();
    
  }

  onPaginationChanged() {
    if (this.gridAPI && !this.gridAPI.destroyed) {
      this.RunlastPage = this.gridAPI.paginationIsLastPageFound();
      this.RuncurrentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.RunnextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.RunnextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.RuntotalPages = this.gridAPI.paginationGetTotalPages();
       const currentPage = this.gridAPI.paginationGetCurrentPage();
  const pageSize = this.gridAPI.paginationGetPageSize();

  const totalRows = this.gridAPI.getDisplayedRowCount(); // better here
  this.totalRows = totalRows;

  if (totalRows === 0) {
    this.startRow = 0;
    this.endRow = 0;
    return;
  }

  this.startRow = currentPage * pageSize + 1;
  this.endRow = Math.min((currentPage + 1) * pageSize, totalRows);
  console.log('pageSize', pageSize);
  console.log('currentPage', currentPage);
  console.log('totalRows', this.totalRows);
  console.log('startRow', this.startRow);
  console.log('endRow', this.endRow);
    }
  }

  onGridReady(params: any) {
    this.gridAPI = params.api;
    this.gridmgrnAPI = params.api;
    this.gridColumnAPI = params.api;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(this.RunpageSize));
    // Build the list shown in the dropdown: only columns that have a field and are not pinned left
    this.toggleableCols = this.columnDefs
      .filter((c) => !!c.field && !c.pinned) // keep "Action" out of the picker
      .map((c) => ({ headerName: c.headerName, field: c.field }));

    // Selected = all non-hidden fields by default
    this.selectedFields = this.columnDefs
      .filter((c) => !!c.field && !c.hide)
      .map((c) => c.field);

    // Apply the "Latest Only" filter if default is true
    // if (this.showLatestOnly) {
    //   this.onToggleLatestOnly(true);
    // }
    // this.loadGridData();
   
  }
 async onStartReview({ event, rowData }: any){
console.log(rowData);
console.log(rowData.reportTemplateId);

 
        if (rowData.status === "No") {
          this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
          return;
        }

    if (rowData.scheduleState == "Completed") {
      this.snackBar.open(
        "This activity is Completed",
        "Ok",
        { duration: 3000 }
      );
      return;
    }
    if (rowData.asignedUser === null) {
      this.snackBar.open(
        "This activity is unassigned. Please self-assign it before continuing.",
        "Ok",
        { duration: 3000 }
      );
      return;
    }

    if (rowData.reportTemplateId === null) {
      this.snackBar.open(
        "This activity is not configured with Report Template. Please configure Report Template.",
        "Ok",
        { duration: 3000 }
      );
      return;
    }

    if (rowData.assignedUserId === this.localStorage.getSettings("UserId")) {
      this.spinner.start();

      const activityEndDate = rowData.activityEndDate;
      const endDate = new Date(activityEndDate);

      const formattedEndDate =
        String(endDate.getDate()).padStart(2, '0') +
        String(endDate.getMonth() + 1).padStart(2, '0') +
        endDate.getFullYear();

      const activityStartDate = rowData.activityStartDate;
      const startDate = new Date(activityStartDate);

      const formattedStartDate =
        String(startDate.getDate()).padStart(2, '0') +
        String(startDate.getMonth() + 1).padStart(2, '0') +
        startDate.getFullYear();

        const today = new Date();

        const formattedDate =
          String(today.getDate()).padStart(2, '0') +
          String(today.getMonth() + 1).padStart(2, '0') +
          today.getFullYear();


      const currentDate = new Date();

      let reportName:any;
      if (endDate < currentDate) {
      reportName =
       "SR"+rowData.productName +
        rowData.reportTemplateId +
        formattedStartDate +
        formattedEndDate+formattedDate;
      } else {
       reportName =
        rowData.productName +
        rowData.reportTemplateId +
        formattedStartDate +
        formattedEndDate+formattedDate;
      }
      

        this.jsignalsService.checkIfReportIsPresentORNot(reportName).subscribe(res=>{
          console.log(res);
            if (res && !res.error) {
              if(res.state == 'Completed' && res.reportinstancedetailsid !=0 ){

              this.showWorkflow = true;
              this.instancedetailid=res.reportinstancedetailsid
              this.selectedActivityReportTemplate=rowData.reportTemplateId
              this.selectedActivity.activityName = rowData.activityName;
              this.selectedActivity.pssName = rowData.pssName;
              this.selectedActivity.assignee = rowData.asignedUser;
              this.selectedActivity.type = rowData.state;
              this.selectedActivity.startDate = rowData.activityStartDate;
               this.selectedActivity.endDate=rowData.activityEndDate;
              this.selectedActivity.version = rowData.version;
              this.selectedActivity.scheduleId = rowData.scheduleId;
              this.selectedActivity.uploadInstructions = rowData.uploadInstructions;
              this.selectedActivity.evidenceRequired = rowData.evidenceRequired;
              this.selectedActivity.isOverdue = rowData.isOverdue;
              this.selectedActivity.reviewActivityType=rowData.reviewActivityType
              console.log("isOverdue",rowData.isOverdue);

              // Only start review if scheduleState(State) is NOT "In Review"
              if (rowData.scheduleState !== "In Review") {
                this.startReviewActivity(
                  rowData.scheduleId,
                  this.localStorage.getSettings("UserId")
                );
              } else {
                console.log(
                  "Activity already in review. Skipping startReviewActivity call."
                );
              }
              this.spinner.stop();
            }else{
               this.snackBar.open(
                "Report generation is already in progress. Please wait while it completes.",
                "Ok",
                { duration: 3000 }
              );
              this.spinner.stop();
            }
          }else{
            this.generateReport(rowData);
          }
        })
        
      
     
    } else {
      this.snackBar.open(
        `This Activity Is Already Assigned to ${rowData.asignedUser}  Please Self-Assign The Activity To Continue`,
        "Ok",
        { duration: 3000 }
      );
    }
  }

  startReviewActivity(scheduleId, UserId) {
    this.spinner.start();
     this.queryData=undefined
    this.jsignalsService.startReviewActivity(scheduleId, UserId).subscribe({
      next: (res: any) => {
        this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
        console.log(res);
        this.loadGridData();
        this.spinner.stop();
      },
      error: (err) => {
        console.error("Assign error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
       
        this.loadGridData();
        this.spinner.stop();
      },
    });
  }

  onBackFromWorkflow(): void {
    this.showWorkflow = false;
    this.queryData=undefined
    this.loadGridData();
  }

  onSelectAssign({ event, rowData }: any): void {

     if (rowData.status === "No") {
        this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
        return;
      }
      if (rowData.scheduleState == "Completed") {
      this.snackBar.open(
        "This activity is Completed",
        "Ok",
        { duration: 3000 }
      );
      return;
    }
    if (rowData.assignedUserId == null) {
      // Case 1: No user assigned yet → directly assign current user
      this.assignUserToActivity(rowData.scheduleId);
    } else if (
      rowData.assignedUserId !== this.localStorage.getSettings("UserId")
    ) {
      // Case 2: Assigned to another user → ask for self-assignment confirmation
      const confirmed = window.confirm(
        `This activity is already assigned to ${rowData.asignedUser}  Do you want to self-assign?`
      );
      if (confirmed) {
        this.assignUserToActivity(rowData.scheduleId);
      } else {
        return;
      }
    } else {
      //   // Case 3: Already assigned to the same user
      this.snackBar.open("Activity Already Assigned To Current User", "Ok", {
        duration: 3000,
      });
    }
  }

applyFilter(status: string) {
  if (!this.gridAPI) return;

  this.activeFilter = status;

  if (status === "Overdue") {
    // Filter using isOverdue flag
    this.gridAPI.setFilterModel({
      isOverdue: {
        filterType: "boolean",
        type: "equals",
        filter: true,
      },
    });
  }
  else if(status === "signaldetected"){
    this.gridAPI.setFilterModel({
      signaldetected: {
        filterType: "text",
        type: "equals",
        filter: "Yes",
      },
       });
  } 
  else {
    // Normal scheduleState filtering
    this.gridAPI.setFilterModel({
      scheduleState: {
        filterType: "text",
        type: "equals",
        filter: status,
      },
    });
  }

  this.gridAPI.onFilterChanged();
}

generateReport(rowData){
  const activityEndDate = rowData.activityEndDate;
const endDate = new Date(activityEndDate);

const formattedEndDate =
  String(endDate.getDate()).padStart(2, '0') +
  String(endDate.getMonth() + 1).padStart(2, '0') +
  endDate.getFullYear();

const activityStartDate = rowData.activityStartDate;
const startDate = new Date(activityStartDate);

const formattedStartDate =
  String(startDate.getDate()).padStart(2, '0') +
  String(startDate.getMonth() + 1).padStart(2, '0') +
  startDate.getFullYear();

const today = new Date();

const formattedDate =
  String(today.getDate()).padStart(2, '0') +
  String(today.getMonth() + 1).padStart(2, '0') +
  today.getFullYear();

console.log(formattedDate); // 15052026
 const currentDate = new Date();

      let reportName:any;
      if (endDate < currentDate) {
      reportName =
       "SR"+rowData.productName +
        rowData.reportTemplateId +
        formattedStartDate +
        formattedEndDate+formattedDate;
      } else {
       reportName =
        rowData.productName +
        rowData.reportTemplateId +
        formattedStartDate +
        formattedEndDate+formattedDate;
      }

let extraFilters: any[] = [];

this.jsignalsService
  .getReportTemplateDetailsBasedOnTemplateId(rowData.reportTemplateId)
  .subscribe(templateRes => {

    const selectedFiltersArray = templateRes.manageFiltersIds
      .split(',')
      .map(id => Number(id.trim()));
console.log(selectedFiltersArray);
console.log("*******************************");

    this.jsignalsService
      .getDatasetDetailsOnDatasetId(Number(templateRes.datasetId))
      .subscribe(datasetRes => {

        if (!datasetRes.error) {
          const columns = JSON.parse(datasetRes.columns);
          console.log(columns);

          const productColumn = columns.find(
            col => col.name === 'product__v.name__v'
          );

          if (productColumn) {
            extraFilters.push({
              label: productColumn.label,
              priority: 'preMax',
              whereKey: productColumn.name,
              whereLogic: 'AND',
              whereValue: rowData.productName,
              excludeNull: false,
              objectWhere: productColumn.object,
              whereValue1: '',
              hideInVisuals: false,
              showOnlyNulls: false,
              whereKeyAlias: productColumn.alias,
              whereCondition: '=',
              mandatoryFilter: true,
              whereConditionValue: '=',
              showInQuicksightVisuals: false,
              displayCalculatedFieldsIn: 'columns',
              multiSelectVaules: [],
              manageFilterId: selectedFiltersArray[0],
              type: 'Object',
              originalCondition: 'Matches',
              originalValue: rowData.productName
            });
          }

           const initialReceiptDateColumn = columns.find(
            col => col.name === 'initial_receipt_date__v'
          );

          if (initialReceiptDateColumn) {
            extraFilters.push({
              label: initialReceiptDateColumn.label,
              priority: 'preMax',
              whereKey: initialReceiptDateColumn.name,
              whereLogic: 'AND',
              whereValue: rowData.activityStartDate,
              excludeNull: false,
              objectWhere: initialReceiptDateColumn.object,
              whereValue1: rowData.activityEndDate,
              hideInVisuals: false,
              showOnlyNulls: false,
              whereKeyAlias: initialReceiptDateColumn.alias,
              whereCondition: "BETWEEN",
              whereConditionValue: "BETWEEN",
              mandatoryFilter: true,
              showInQuicksightVisuals: false,
              displayCalculatedFieldsIn: 'columns',
              multiSelectVaules: [],
              manageFilterId: selectedFiltersArray[0],
              type: 'Object',
              originalCondition: 'Matches',
              originalValue: rowData.productName
            });
          }

        }

        this.reviewAcitivityReportFiltersServices.getFiltersList(
          selectedFiltersArray,
          Number(templateRes.datasetId),
          rowData.reportTemplateId,
          reportName,
          extraFilters
        );

        this.spinner.stop();
      });
  });
}
  clearFilter() {
    if (!this.gridAPI) return;

    this.activeFilter = null;
    this.gridAPI.setFilterModel(null);
    this.gridAPI.onFilterChanged();
  }

  loadGridData() {
    let userId = this.localStorage.getSettings("UserId");
    const workSpaceId = this.localStorage.getSettings("WorkspaceId");
    console.log("Workspace ID:", workSpaceId);
    console.log("User ID:", userId);
    this.spinner.start();
    this.jsignalsService
      .getAllActivitesBasedOnRole(userId,workSpaceId)
      .subscribe({
        next: (res: any) => {
          console.log("Content loaded:", res);
          // this.gridRowData = res;
          try {
          // Added By Rahulvk :- Send gridRowData to process Overdue PSS
          this.gridRowData = res.map(row => this.processActivityRow(row));  
          // Compute statistics
          this.calculateStats();
          this.generateCalendarEvents(this.gridRowData);
          if(this.queryData){
            
              let stateData=this.queryData
            // let searchedRowData=this.gridRowData.filter(item=>item.id==stateData.id)[0];
            this.onStartReviewBasedOnSearch(stateData)
          }
          this.spinner.stop();
          } catch (error) {
            this.snackBar.open(error, "Ok", { duration: 3000 });
            this.spinner.stop();
          }
          //  Refresh grid data  only after API returns
          if (this.gridAPI) {
            this.gridAPI.setGridOption('rowData', this.gridRowData);
            const currentPage = this.gridAPI.paginationGetCurrentPage();
            const pageSize = this.gridAPI.paginationGetPageSize();

            const totalRows = this.gridAPI.getDisplayedRowCount(); // better here
            this.totalRows = totalRows;

            if (totalRows === 0) {
              this.startRow = 0;
              this.endRow = 0;
              return;
            }

            this.startRow = currentPage * pageSize + 1;
            this.endRow = Math.min((currentPage + 1) * pageSize, totalRows);
            console.log('pageSize', pageSize);
            console.log('currentPage', currentPage);
            console.log('totalRows', this.totalRows);
            console.log('startRow', this.startRow);
            console.log('endRow', this.endRow);
          }
        },
        error: (err) => {
          console.error("Error loading Content:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
          this.gridRowData = [];
          if (this.gridAPI) this.gridAPI.setGridOption('rowData', []);
          this.spinner.stop();
        },
      });
  }

  fetchUserRole() {
    this.linkservice
      .fetchUserRole(
        this.localStorage.getSettings("dnsName"),
        this.localStorage.getSettings("AuthUsername")
      )
      .subscribe((res: any) => {
        console.log(res.roleName);
        this.UserRoleName = res.roleName;
        this.loadGridData();
      });
  }
  calculateStats() {
    this.newCount = this.gridRowData.filter(
      (d) => d.scheduleState === "New"
    ).length;
    this.inReviewCount = this.gridRowData.filter(
      (d) => d.scheduleState === "In Review"
    ).length;
    this.completedCount = this.gridRowData.filter(
      (d) => d.scheduleState === "Completed"
    ).length;
    this.overdueCount = this.gridRowData.filter(
      (d) => d.isOverdue == true
    ).length;
    this.signalDetectedCount  = this.gridRowData.filter(
      (d) => d.signaldetected == 1 || d.signaldetected === "1"
    ).length;
  }
  /** Handle click vs double-click */
  onCardClick(status: string) {
    if (this.clickTimeout) {
      // Double-click detected → clear filter
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
      this.clearFilter();
      return;
    }

    // Single-click detected (wait to confirm it's not a double)
    this.clickTimeout = setTimeout(() => {
      this.clickTimeout = null;
      this.applyFilter(status);
    }, 250); // 250ms threshold for double-click
  }

  assignUserToActivity(scheduledId) {
    this.spinner.start();
     this.queryData=undefined
    this.jsignalsService
      .selfAssignCurrentUserToActivity(
        scheduledId,
        this.localStorage.getSettings("UserId")
      )
      .subscribe({
        next: (res: any) => {
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          console.log(res);
          this.loadGridData();
          this.spinner.stop();
        },
        error: (err) => {
          console.error("Assign error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.loadGridData();
          this.spinner.stop();
        },
      });
  }

  // In data Send latestApprovedPSS[] to popup Component to load the PSS name and Extract Id to add new Activity to that PSS
  openAddhocActivityPopUp() {
     this.queryData=undefined
    this.dialog.open(NewAdhocActivityPopupComponent, {
      maxWidth: "100vw",
      height: "95%",
      width: "90%",
      data: this.latestApprovedPSS,
      disableClose: true,
    })
  .afterClosed()
  .subscribe((result) => {
    if (result) {
      this.loadGridData(); // receives latest data
    }
  });
  }
  getAllLatestApprovedPSS(){
    this.spinner.start();
    this.jsignalsService
      .getAllLatestApprovedPss()
      .subscribe({
        next: (res: any) => {
          console.log(res);
          this.latestApprovedPSS = res;
          this.spinner.stop();
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.latestApprovedPSS = []
          this.spinner.stop();
        },
      });
  }

  deleteIcon({rowData}){
    if (rowData.status === "No") {
        this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
        return;
      }
    if(rowData.state == "SCHEDULED"){
        this.snackBar.open("Scheduled activity not allowed to delete", "OK", { duration: 5000 });
        return;
      }
    const confirmed = window.confirm(
      "Are you sure you want to delete the selected record ?"
    );
    if (!confirmed) {
      return;
    }
      this.jsignalsService
      .deleteAddHocReviewActivityByActivityId(rowData.activityId)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
        },
      });  
  }


   /*
   @Author : Rahul Vk 
   @date : 10/11/25
   @param row 
   @note :- Recevie gridRowData From  loadGridData() processes the entire GridRowData 
            compares current date with activityDueDate and status !== Completed 
            sets the isOverdue(Flag added in Ui) as Overdue
   */
 private processActivityRow(row: any) {
  const updatedRow = { ...row };

  try {
    updatedRow.isOverdue = false; // default

    updatedRow.isOverdue = this.isActivityOverdue(updatedRow);

  } catch (error) {
    console.error(error);
    this.snackBar.open(error, "Ok", { duration: 3000 });
  }

  return updatedRow;
}

onSignalCreation({rowData}){
  console.log("Selected row state :",rowData.scheduleState);
  console.log("Selected row  :",rowData);
      if (rowData.status === "No") {
        this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
        return;
      }
  //   if(rowData.scheduleState !== "Completed"){
  //   this.snackBar.open("Please complete the activity before creating a signal.","Ok",{duration:3000})
  //   return;
  // }

  // Note :- Signal detected in Grid is Shown yes/no but in db stored as 0/1 
  /**
   * @note :- Signal Created from review activity signalType is set to INTERNAL 
   */
  if(rowData.signaldetected === "0"){
    this.snackBar.open("Signal is not detected for this activity","Ok",{duration:3000})
    return;
  }
this.dialog.open(CreateSignalPopupComponent, {
      maxWidth: "100vw",
      height: "95%",
      width: "90%",
      data: {rowData,hideProductSelection: true, mode: "create",signalType:"INTERNAL"},
      disableClose: true,
    })
  .afterClosed()
  .subscribe((result) => {
    if (result) {
      this.createSignalFromActivity(result);
      
    }
  });
}

/*
 @Added By Rahul Vk 
 @date 30-12-25

@param Devaition_for , Unique_record_id , deviationId

@note:- Unique_record_id Should be Primary key of the record for which deviation has to be created 
 */
onDeviationCreation({rowData}){
   this.queryData=undefined
  if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
   return;
     }
  //Not overdue → deviation not allowed
if (!this.isActivityOverdue(rowData)) {
  this.snackBar.open(
    'Deviation can be created only for overdue activities.',
    'OK',
    { duration: 5000 }
  );
  return;
}   
  if (rowData.deviationState === 'COMPLETED') {
  this.snackBar.open('Deviation is already completed.','OK',{ duration: 5000 });
  return;
}   
      this.dialog.open(DeviationComponent, {
      maxWidth: "100vw",
      height: "97%",
      width: "90%",
      data: { deviationFor:this.deviationFor,
              uniqueRecordId:rowData.scheduleId,
              deviationId:rowData.deviationId, // If deviation Id present in RowData open Form in Edit Mode

              productName:rowData.productName,
              productId:rowData.productId,    
              
              //Header context 
              headerContext: [
                { label: 'Activity', value: rowData.activityName },
                { label: 'Product', value: rowData.productName },
                { label: 'PSS', value: rowData.pssName },
                { label: 'Version', value: rowData.version }
              ].filter(item => item.value) // removes empty values
            },
      disableClose: true,
    })
  .afterClosed()
  .subscribe((result) => {
    if (result) {
      this.loadGridData(); // receives latest data
    }
  });
}

private isActivityOverdue(row: any): boolean {
  if (!row?.activityDueDate) {
    return false;
  }

  const dueDate = new Date(row.activityDueDate);
  if (isNaN(dueDate.getTime())) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    dueDate < today &&
    row.scheduleState !== 'Completed'
  );
}

private mustCreateDeviation(row: any): void {
 if (
    this.isActivityOverdue(row) &&
    !row.deviationStatus
  ) {
    this.snackBar.open(
      'Activity is overdue. Please create a deviation before proceeding.',
      'Ok',
      { duration: 4000 }
    );
    throw new Error('Deviation required'); // stops execution safely
  }
}

getDeviationUrl(params: any): string {
  const deviationId = params.rowData.deviationCode;

  const screenPath = this.userRoutingModule.print(
    'DeviationManagementComponent'
  );

  return this.router.serializeUrl(
    this.router.createUrlTree(
      ['/user/Menubar', screenPath, deviationId] // 👈 ID after path
    )
  );
}

calendarEvents: CalendarEvent[] = [];

openCalendarDialog() {
  // Open dialog with calendar
  this.dialog.open(ActionCalendarComponent, {
    width: '800px',
    data: { events: this.calendarEvents }
  });
}
generateCalendarEvents(rows: any[]): void {
  this.calendarEvents = rows.map(action => ({
    id: action.scheduleId || action.activityId,  // ✅ Use scheduleId or activityId
    title: action.activity || action.activityName,  // ✅ Use activity or activityName
    date: new Date(action.activityDueDate || action.reviewCompletionDate),  // ✅ Use activityDueDate
    type: this.getEventType(action),  // ✅ Use helper method to determine type
    link: `/actions/${action.scheduleId}`,  // ✅ Use scheduleId for link
    data: {  // ✅ Put all additional data in the data property
      priority: action.priority,
      state: action.scheduleState,
      productName: action.productName,
      pssName: action.pssName,
      assignee: action.asignedUser,
      signalDetected: action.signaldetected,
      deviationCode: action.deviationCode,
      isOverdue: action.isOverdue
    }
  })).filter(event => event.date && !isNaN(event.date.getTime())); // Filter out invalid dates
}

// Add this helper method to determine event type
private getEventType(action: any): string {
  if (action.scheduleState === 'Completed') {
    return 'completed';
  } else if (action.isOverdue === true) {
    return 'overdue';
  } else if (action.scheduleState === 'In Review') {
    return 'in-review';
  } else if (action.signaldetected === 1 || action.signaldetected === '1') {
    return 'signal-detected';
  } else {
    return 'open';
  }
}

createSignalFromActivity(payload:any){
  const createPayload = [payload];
 this.queryData=undefined
    console.log("Payload from activity to signal creation :",createPayload);
  this.spinner.start();
  this.jsignalsService
      .createSignal(createPayload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            this.loadGridData(); // receives latest data
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
          this.loadGridData(); // receives latest data
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
          this.loadGridData(); // receives latest data
        },
      });  
  
}

  onStartReviewBasedOnSearch(rowData: any): void {
console.log(rowData);
console.log(rowData.reportTemplateId);

 
        if (rowData.status === "No") {
          this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
          return;
        }

    if (rowData.scheduleState == "Completed") {
      this.snackBar.open(
        "This activity is Completed",
        "Ok",
        { duration: 3000 }
      );
      return;
    }
    if (rowData.asignedUser === null) {
      this.snackBar.open(
        "This activity is unassigned. Please self-assign it before continuing.",
        "Ok",
        { duration: 3000 }
      );
      return;
    }

    if (rowData.reportTemplateId === null) {
      this.snackBar.open(
        "This activity is not configured with Report Template. Please configure Report Template.",
        "Ok",
        { duration: 3000 }
      );
      return;
    }

    if (rowData.assignedUserId === this.localStorage.getSettings("UserId")) {
      this.spinner.start();
      console.log("in side Review");
      this.showWorkflow = true;
      this.selectedActivityReportTemplate=rowData.reportTemplateId
      this.selectedActivity.activityName = rowData.activityName;
      this.selectedActivity.pssName = rowData.pssName;
      this.selectedActivity.assignee = rowData.asignedUser;
      this.selectedActivity.type = rowData.state;
      this.selectedActivity.startDate = rowData.activityStartDate;
      this.selectedActivity.version = rowData.version;
      this.selectedActivity.scheduleId = rowData.scheduleId;
      this.selectedActivity.uploadInstructions = rowData.uploadInstructions;
      this.selectedActivity.evidenceRequired = rowData.evidenceRequired;
      this.selectedActivity.isOverdue = rowData.isOverdue;
      this.selectedActivity.reviewActivityType=rowData.reviewActivityType
      console.log("isOverdue",rowData.isOverdue);

      // Only start review if scheduleState(State) is NOT "In Review"
      if (rowData.scheduleState !== "In Review") {
        this.startReviewActivity(
          rowData.scheduleId,
          this.localStorage.getSettings("UserId")
        );
      } else {
        console.log(
          "Activity already in review. Skipping startReviewActivity call."
        );
      }
    } else {
      this.snackBar.open(
        `This Activity Is Already Assigned to ${rowData.asignedUser}  Please Self-Assign The Activity To Continue`,
        "Ok",
        { duration: 3000 }
      );
    }
  }
}
